import {
    SET_INPUT_HISTORY
} from '../actions/types';

const initialState = {
    item: {}
}

export default function(state=initialState, action) {
    switch(action.type) {
        case SET_INPUT_HISTORY:
            return {
                ...state,
                item: action.payload
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/inputReducer.js